// TEST
export const TEST_URL = 'https://yafintegration-test.mobileapp.severstal.com/api';

export const URL = `${window.location.protocol}//${window.location.hostname}/api`;

export const BASE_URL =  process.env.NODE_ENV === 'development' ? TEST_URL : URL; 